export default {
  data(){
    return {
      isFirstRequest: true,
    }
  },
  methods: {
    configureMobile(){

      if(window.outerWidth < this.mobileModeMinWidth) {

        /**
         * Mobile
         */
        this.updateMobileMode(true);
        this.updateMapConfig({draggable: false});
      } else {
        /**
         * Desktop
         */
        // this.changeMapView();

      }


    },

    
    onMapIdle({bounds, center, zoom}){
      const vm = this;
      if(!bounds) {
        console.error('onMapIdle :: invalid bounds');
        return false;
      }
      if(!this.isFirstRequest){ 
        console.log('onMapidle :: is not first request');
        return false; 
      }
      this.changeBoundsSearchParams(bounds)
        .then(() => {
          vm.loadNewProperties({initial: true}); // this is the initial request, make sure the loc_cd is sent with the API request so that the API knows to log the request to the DB
        })
        .catch(() => {
          // @ToDo: map tried to initialize withoutbounds
        });

    },

    setupMapConfig(mobileMode = false){

      return new Promise((resolve, reject) => {


        const vm = this;
        let mapOptions = {};

        /**
        * Tell the map plugin to use these bounds to draw the map
        */
        if(this.searchParams.lat && this.searchParams.lng){
          /**
          * Tell the map plugin to use these coords to center and draw the map
          */
          mapOptions.center = {
            lat: parseFloat(this.searchParams.lat),
            lng: parseFloat(this.searchParams.lng)
          };
        } else if( !mapOptions.center || !(mapOptions.center.lat || mapOptions.center.lng) ) {
          /*
          *  If we don't have anything to initialize the map with, don't initialize it
          */
         resolve(false);
         return false;
        }
        
        if(this.searchParams.zoom){
          mapOptions.zoom = parseInt(this.searchParams.zoom);
        } else if(mobileMode){
          // On mobile where the map is smaller, zoom out to max to give the search a better chance to catch the user's listings insiode the map bounds
          // Response to a helpdesk ticket where a user was not seeing their listings when they opened their agent website
          // https://rwhelpdesk.sdpondemand.manageengine.com/app/itdesk/ui/requests/92794000008906491/details
          mapOptions.zoom = 9;
        }

        /**
         * Set the initial zoom level
         * -- DISABLED due to removal of loc_level -- this needs to be returned by google in order to bring this back
         */
        // let loc_level = this.searchParams.loc_cd.split('-')[0];
        // uses cityZoom, countyZoom, zipcodeZoom
        // mapOptions.zoom = defaultZoomLevels[vm.searchType][loc_level];

        this.updateMapConfig(mapOptions);

        resolve(mapOptions);

      });

    },

    
    onBoundsChange: _.debounce(function(bounds){
      
      if(!bounds) { console.error('onBoundsChange :: Invalid Bounds'); return false; }
      if(this.appName == 'agent-websites-app' && this.mapView == -1) { console.warn('\nonBoundsChange fired when map is not visible\n'); return false; }

      
      
      // if(!this.locationChanging && this.mobileMode && this.mapView == -1) { 
      //   console.warn('map bounds changed while map was hidden. ignoring');       
      //   return false; 
      // }
      const vm = this;
      vm.changeLoading(true);
      this.clearHighlightedProperty();
      vm.updateSearchParams({lat: vm.mapConfig.center.lat, lng: vm.mapConfig.center.lng});
      this.changeBoundsSearchParams(bounds)
        .then(() => {
          /**
           * When the map initializes, there is a bounds change event that fires. We need to prevent this event from causing a request to the API. This is causing 2 requests to go to the API with every page load.
           */
          if(!this.isFirstRequest){
            vm.updateMarkers([]);
            vm.loadNewProperties({resetPage: true});
          } else {
            /**
             * Tell the app that subsequent calls to this method can send requests to the API for properties
             */
            vm.isFirstRequest = false;
          }
        })
        .catch((err) => {
          console.error(err);
          vm.changeLoading(false);
        });
    }, 200),

    onHighlightProperty: _.debounce(function(property){
      if(this.resultsExpanded == 1) return false;
      this.updateHighlightedProperty(property);
    }, 20),

    onClearHighlightedProperty: _.debounce(function(){
      if(this.resultsExpanded == 1) return false;
      this.clearHighlightedProperty();
    }, 20),
    
  }
};